import * as Icons from "lucide-react";
import { ArrowRight, Clock } from "lucide-react";
import { SERVICES } from "../data/clinic";

export default function Services() {
  const goTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section data-testid="services-section" id="services" className="lfc-section relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#251047]/40 via-transparent to-[#251047]/40 pointer-events-none" />
      <div className="absolute top-1/3 -left-24 w-72 h-72 rounded-full bg-[#7B46D9]/15 blur-[100px] pointer-events-none" />

      <div className="lfc-container relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="lfc-eyebrow mb-4">Our services</div>
            <h2 className="lfc-h2">
              Comprehensive foot care, <br className="hidden md:block" />
              tailored to your needs.
            </h2>
            <div className="lfc-divider-leaf mt-6" />
          </div>
          <div className="lg:col-span-5">
            <p className="text-lg text-[#C2B4E6] leading-relaxed">
              From routine maintenance to advanced treatments like nail bracing,
              fenestration and Verruca Banish — we offer a complete range of
              medical and routine services in the comfort of your home.
            </p>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Stethoscope;
            return (
              <article
                key={s.id}
                id={`service-${s.id}`}
                data-testid={`service-card-${s.id}`}
                className="lfc-card p-7 flex flex-col"
              >
                <div className="flex items-center gap-3">
                  <div className="grid place-items-center w-11 h-11 rounded-xl bg-[#1B0B3A] text-[#5FE6E0] border border-[#2BB8B4]/40">
                    <Icon className="w-5 h-5" strokeWidth={1.6} />
                  </div>
                </div>

                <h3
                  className="mt-5 text-[20px] font-semibold leading-snug text-white"
                  style={{ fontFamily: "Outfit" }}
                >
                  {s.title}
                </h3>

                {s.duration && (
                  <div className="mt-3 inline-flex items-center gap-1.5 self-start px-3 py-1 rounded-full bg-[#2BB8B4]/10 border border-[#2BB8B4]/30 text-[12px] font-medium text-[#5FE6E0]">
                    <Clock className="w-3 h-3" strokeWidth={2} />
                    {s.duration}
                  </div>
                )}

                <p className="mt-3 text-[15px] text-[#C2B4E6] leading-relaxed">
                  {s.short}
                </p>

                <ul className="mt-5 space-y-2">
                  {s.bullets.map((b) => (
                    <li
                      key={b}
                      className="flex items-start gap-2.5 text-[14.5px] text-[#E5DEFA]"
                    >
                      <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#2BB8B4] shrink-0" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>

                <div className="mt-7 pt-5 border-t border-[#4A2D7A]">
                  <button
                    onClick={() => goTo("contact")}
                    data-testid={`service-enquire-${s.id}`}
                    className="inline-flex items-center gap-2 text-[14.5px] font-medium text-[#5FE6E0] hover:gap-3 hover:text-white transition-all duration-300"
                  >
                    Enquire about this service
                    <ArrowRight className="w-4 h-4" strokeWidth={1.8} />
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
